import React from 'react'

function Password(props){

        return (
            <div className='row entry'>
                <form onSubmit={props.onSubmit}>
                    {/* <div className="form-inline float-md-right"> */}
                        <p className="">Enter password to view Bespoke Reports</p>
                        <input type='password' placeholder="Enter Password" value={props.password} onChange={props.onChange} id='query' />
                        <button type='submit' className='bluebutton'>SUBMIT</button>
                    {/* </div> */}
                </form>
            </div>
        );
}

export default Password;